/**
 * Org HTTP service (PX-W6.2) — settings, security settings, access groups and
 * the read-only tenant policy, over the ONE shared transport.
 */

import { apiClient } from '@/services'

import type {
  AccessGroup,
  AccessGroupInput,
  OrgSettings,
  SecuritySettings,
  TenantPolicy
} from './types'

export const orgHttp = {
  getSettings(): Promise<OrgSettings> {
    return apiClient.get<OrgSettings>('/{orgId}/settings')
  },

  updateSettings(body: OrgSettings): Promise<OrgSettings> {
    return apiClient.put<OrgSettings>('/{orgId}/settings', body)
  },

  getSecurity(): Promise<SecuritySettings> {
    return apiClient.get<SecuritySettings>('/{orgId}/settings/security')
  },

  updateSecurity(body: SecuritySettings): Promise<SecuritySettings> {
    return apiClient.put<SecuritySettings>('/{orgId}/settings/security', body)
  },

  listAccessGroups(): Promise<AccessGroup[]> {
    return apiClient.get<AccessGroup[]>('/{orgId}/settings/access-groups')
  },

  createAccessGroup(input: AccessGroupInput): Promise<AccessGroup> {
    return apiClient.post<AccessGroup>('/{orgId}/settings/access-groups', input)
  },

  updateAccessGroup(groupId: string, input: AccessGroupInput): Promise<AccessGroup> {
    return apiClient.put<AccessGroup>(`/{orgId}/settings/access-groups/${groupId}`, input)
  },

  deleteAccessGroup(groupId: string): Promise<void> {
    return apiClient.delete<void>(`/{orgId}/settings/access-groups/${groupId}`)
  },

  tenantPolicy(): Promise<TenantPolicy> {
    return apiClient.get<TenantPolicy>('/{orgId}/tenant-policy')
  }
}
